import IfscCodeMapper from "../../../IfscLogoMapper";
import { standardAccountNumberFormat } from "../../../../../utils/standardAccountNumberFormat";
import FormatAmount from "../../../FormatAmount/FormatAmount";
import SVGComponent from "../../../SVGComponent";
import TickerAnimation from "../../../TickerAnimation";
/**
 * @typedef {("AccountNumber" | "Amount" | "Text")} type
 * @typedef {("lowercase" | "uppercase" | "capitalize")} textCase
 * @param {Object} props
 * @param {String} props.text - Header text
 * @param {String} props.src - icon for cta button
 * @param {String} props.subText - Subtext
 * @param {String} props.ifscCode - ifsc code for bank logo
 * @param {type} props.type - type of the header text
 * @param {textCase} props.textCase - text casing of the header text
 * @param {String} props.imgColor - Color for icon if needed (var Only)
 * @returns {JSX.Element}
 */
const TextWithBank = ({
  text,
  subText,
  ifscCode,
  src,
  type,
  textCase,
  imgColor,
}) => {
  return (
    <div className="flex gap-x-gap-sm justify-between items-center">
      <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
        <p
          style={{
            textTransform: textCase,
          }}
          className={`text-font-sm text-text-primary flex-1 truncate font-normal pl-padding-sm`}
        >
          {type === "Amount" ? (
            <>
              INR <FormatAmount price={Number(text)} />
            </>
          ) : type === "AccountNumber" ? (
            standardAccountNumberFormat(text)
          ) : (
            <TickerAnimation text={text} />
          )}
        </p>
        <div className="w-full relative flex pl-padding-sm justify-between items-center ">
          <p
            className={`text-font-xs text-text-secondary flex-1 truncate font-normal transform-none`}
          >
            {subText}
          </p>
        </div>
      </div>
      <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
        {src ? (
          <>
            <SVGComponent
              url={src}
              color={imgColor}
              height={"var(--icon-sm)"}
              width={"var(--icon-sm)"}
            />
            <div
              style={{
                width: "var(--border)",
                display: ifscCode ? "flex" : "none",
              }}
              className="h-auto border-l-border py-padding-button-m border-primary-nav "
            ></div>
          </>
        ) : null}
        {ifscCode ? (
          <div className="w-banklogo-width-sm h-icon-xs flex-shrink-0">
            <IfscCodeMapper ifscCode={ifscCode} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default TextWithBank;
